export default "<m-plane\n    x=\"3\"\n    y=\"2\"\n    z=\"3\"\n    color=\"orange\"\n></m-plane>\n";